import styled from "styled-components";
import { GuaranteeDataContainer } from "../../health/health- guarantee/guarantee-data-style";

export const HealthForeignersGuaranteeContainer = styled(GuaranteeDataContainer)``;
